import { ISearchOrdersSettingsData } from './ISearchOrdersSettingsData';
import { createDefaultVendorOrderData, IVendorOrderData, IVendorOrderResponse } from './IVendorOrders';
import { IQueryResponse } from '../rest/IQueryResponse';

export interface IVendorTaxCertificationsPagedResponse extends IQueryResponse<TaxCertificationRequests> {}

export interface TaxCertificationRequests extends Omit<IVendorOrderResponse, 'titleSearchId'> {
  taxCertificationRequestId: string;
  eta?: string;
}

export interface IVendorTaxCertificationsResponse {
  taxCertificationRequests: IVendorTaxCertificationResponse[];
  page: number;
  pageSize: number;
  total: number;
}

export interface IVendorTaxCertificationsData {
  taxCertificationRequests: IVendorTaxCertificationData[];
  total: number;
}

export const createDefaultVendorTaxCertificationsData = (): IVendorTaxCertificationsData => ({
  taxCertificationRequests: [],
  total: 0,
});

export const convertFromVendorTaxCertificationsResponseToVendorTaxCertificationsData = (
  data: IVendorTaxCertificationsPagedResponse
): IVendorTaxCertificationsData => ({
  taxCertificationRequests: data.content,
  total: data.totalElements,
});

export const convertFromVendorTaxCertificationsDataAndSearchSettingsToVendorTaxCertificationsResponse = (
  data: IVendorTaxCertificationsData,
  searchSettings: ISearchOrdersSettingsData
): IVendorTaxCertificationsResponse => ({
  taxCertificationRequests: data.taxCertificationRequests,
  page: searchSettings.page,
  pageSize: searchSettings.pageSize,
  total: data.total,
});

export interface IVendorTaxCertificationResponse extends Omit<IVendorOrderResponse, 'titleSearchId'> {
  taxCertificationRequestId: string;
  eta?: string;
}

export interface IVendorTaxCertificationData extends Omit<IVendorOrderData, 'titleSearchId'> {
  taxCertificationRequestId: string;
  eta?: string;
}

export const createDefaultVendorTaxCertificationData = (): IVendorTaxCertificationData => {
  const { titleSearchId, ...rest } = createDefaultVendorOrderData();
  return {
    ...rest,
    taxCertificationRequestId: '',
  };
};

export const convertFromVendorTaxCertificationResponseToVendorTaxCertificationData = (
  data: IVendorTaxCertificationResponse
): IVendorTaxCertificationData => data;
export const convertFromVendorTaxCertificationDataToVendorTaxCertificationResponse = (
  data: IVendorTaxCertificationData
): IVendorTaxCertificationResponse => data;
